import { render, staticRenderFns } from "./QuoteExcessInvoice.vue?vue&type=template&id=1a856515&scoped=true"
import script from "./QuoteExcessInvoice.vue?vue&type=script&lang=js"
export * from "./QuoteExcessInvoice.vue?vue&type=script&lang=js"
import style0 from "./QuoteExcessInvoice.vue?vue&type=style&index=0&id=1a856515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a856515",
  null
  
)

export default component.exports